// preserve_br.js
//
// 解決 Redactor 在 HTML source ⇆ WYSIWYG 切換時，頂層獨立 <br> 與空 <p></p>
// 被 paragraphizer 清理掉的問題。
//
// 根本原因：
//   paragraphizer._parse() 會把頂層（不在任何 block 元素內）的 <br>
//   包裝成 <p><br></p>，再由清理規則轉為空的 <p></p>，導致 <br> 遺失。
//
// 做法：
//   - editor.before.parse：在 paragraphizer 執行前，把頂層 <br> 替換成
//     帶有自訂屬性的 <div>（block 元素），讓 _storeTags() 整個儲存跳過處理。
//   - editor.unparse：在輸出 HTML 時（切換回 source / sync 到 form textarea），
//     把 placeholder <div> 與空的 <p></p> 統一還原為 <br>。
//
// 使用方式（於 buildRedactor 的 subscribe 中展開）：
//   import { preserveBrSubscribe } from './preserve_br'
//   subscribe: { ...preserveBrSubscribe, ...otherCallbacks }

export const preserveBrSubscribe = {
  // 在 paragraphizer 執行前攔截，將頂層獨立 <br> 替換成 placeholder <div>
  'editor.before.parse': function(event) {
    const html = event.get('html')
    const wrapper = document.createElement('div')
    wrapper.innerHTML = html
    // 只處理直接子節點（頂層）的 <br>；<p> 內部的 <br> 已由 _storeTags 保護，不受影響
    Array.from(wrapper.childNodes).forEach(node => {
      if (node.nodeName === 'BR') {
        const placeholder = document.createElement('div')
        placeholder.setAttribute('data-rx-br-placeholder', 'true')
        wrapper.replaceChild(placeholder, node)
      }
    })
    event.set('html', wrapper.innerHTML)
  },

  // 輸出 HTML 時還原：placeholder → <br>，空 <p></p> → <br>
  'editor.unparse': function(event) {
    const html = event.get('html')
    const wrapper = document.createElement('div')
    wrapper.innerHTML = html
    // 1. 還原 before.parse 建立的 placeholder
    wrapper.querySelectorAll('[data-rx-br-placeholder]').forEach(node => {
      node.parentNode.replaceChild(document.createElement('br'), node)
    })
    // 2. 空的 <p>（無任何可見內容）也轉為 <br>，使 HTML source 保持一致
    wrapper.querySelectorAll('p').forEach(node => {
      if (node.innerHTML.trim() === '') {
        node.parentNode.replaceChild(document.createElement('br'), node)
      }
    })
    event.set('html', wrapper.innerHTML)
  },
}
